import React from "react";
import PropTypes from "proptypes";

const ItineraryModal = ({ closeModal, mailingCountry }) => (
  <div>
    <div className="row">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
    </div>
        <h3>BOOKING WITH SCHOLARTRIP</h3>
        <p>
          You are responsible for booking your own flights to and from your trip location. 
          GIVE partners with dedicated flight agents at Scholartrip so you can book your flights with ease, 
          access our Airfare Deposit program and exclusive discounts, receive 24/7 flight support, and when possible, 
          fly with other travelers on your trip! With the <b>Airfare Deposit Program, you can book flights
          with just a deposit</b>, then your remaining flight balance is due 3-weeks before your trip!
        </p>
        <p>
          GIVE will email you once flights are released for your trip, which is also visible from your GIVE Profile.
          Once flights are released, submit your flight booking request form below, then our agents will email itinerary 
          quotes and assist you to book your round trip flights from your home city to your host location. It's that easy!  
          It's important to book your flights as soon as possible to receive the lowest fares. Flight prices fluctuate 
          daily as there are only a select number of seats at a given price each day and these prices change based on 
          availability. There are no guarantees on ticket prices. Make sure to book your flights early!
        </p>

        <h4>HOW TO BOOK</h4>
        <p>
          <b>1. </b> Submit a booking{" "}
          <a
            href="https://go.givevolunteers.org/bookflights"
            target="_blank"
            rel="noopener noreferrer"
          >
            booking request form
          </a>
          !
        </p>
        <p>
          <b>2. </b>
          After purchasing your flights through Scholartrip, enter your
          arrival and departure flight numbers and dates here on your GIVE Profile
          under the Flight Itinerary section of your Trip Checklist.
        </p>

        <ul>
          <li>
            Have questions about your airfare quotes or flights? Email:{" "}
            <a href="mailto:give@scholartrip.com">give@scholartrip.com</a>{" "}
            (only email general questions – for flight quotes, submit a booking form)
          </li>
        </ul>

        <h4>WHY SHOULD I BOOK WITH GIVE'S DEDICATED AGENTS?</h4>
        <ul>
          <li>
            With their Airfare Deposit Program, you can book your flights with just a deposit ranging from $300-$500, 
            then pay the balance later!</li>
          <li>
            They will help you to fly with other travelers on your trip!</li>
          <li>
            They will make sure that your layovers are not too short so you
            don’t miss your connecting flight!
          </li>
          <li>
            They will provide you with exceptional 24/7 support while traveling
            – this service is not available when booking on your own.{" "}
          </li>
          <li>
            {" "}
            If you still want to shop for your own flights, email Scholartrip
            to see if they can price match your preferred itinerary!
          </li>
        </ul>
      <h4>SPECIAL BOOKING CIRCUMSTANCES</h4>
      <p>
        GIVE volunteers have a spark for adventure, so we understand if you’d
        like to arrive early or extend your flights to continue traveling. We
        also know that some volunteers prefer to book with miles. If you’d like
        to book your flights outside of our booking agents, then we require you
        to email us your preferred itinerary prior to booking. Note that if you
        arrive or depart outside of our suggested itinerary times, you will be
        responsible for your own airport transportation and any additional
        accommodation fees outside of your GIVE excursion dates.
      </p>
  </div>
);

ItineraryModal.propTypes = {
  mailingCountry: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default ItineraryModal;
